import React from "react";
import { Col, Row } from "react-bootstrap";

export default function Advertisement() {
    return (
        <>
            <div className="aboutus_bg">
                <div className="aboutus-img-content">
                    <h1>Marketing & Advertising Strategy</h1>
                </div>
            </div>
            <div className="container my-5">
                <div className="row">
                    {/* Main Content Section */}
                    <div className="col-lg-8 vendor-main-content">
                        <img
                            src="images/add.jpg"
                            alt="Emergency Fund Management"
                            className="img-fluid"
                        />
                        <p>Build your brand and expand reach with targeted marketing that converts prospects into loyal customers.</p>
                        <h2 style={{fontWeight:'bold'}}>Our Expertise</h2>
                        <p>
                            <ul>
                                <li><b>Brand positioning and messaging</b> <br /><br/></li>
                                <li><b>Integrated marketing plans (social media, SEO, email, paid ads)</b> <br /><br/></li>
                                <li><b>Digital campaign management</b> <br /><br/></li>
                                <li><b>Analytics and reporting</b> <br/><br/></li>
                                <li><b>Creative asset creation (graphics, videos)</b></li>
                            </ul>
                        </p>
                        
                    </div>

                    {/* Sidebar Section */}
                    <div className="col-lg-4 vendor-sidebar">
                        {/* Why Choose Us */}
                        <div className="vendor-section vendor-services">
                            <h3 style={{fontWeight:'bold'}}>Benefits</h3>
                            <ul>
                                <li><span class="arrow">➤</span>Lead generation and sales growth</li>
                                <li><span class="arrow">➤</span>Enhanced brand awareness</li>
                                <li><span class="arrow">➤</span>Improved online presence and SEO</li>
                                <li><span class="arrow">➤</span>Optimized marketing ROI</li>
                            </ul>
                        </div>

                        {/* Latest Posts */}
                        <div className="vendor-section vendor-latest-posts" style={{ marginBottom: '20px' }}>
                            <img
                                src="images/adver.jpg"
                                alt="Emergency Fund Management"
                                className="img-fluid"
                            />
                            
                        </div>
                        {/* Contact Info */}
                        {/* <div className="vendor-section vendor-contact-info">
                            <h3 style={{fontWeight:'bold'}}>Contact Info</h3>
                            <p>
                                <span> <i class="fa-solid fa-location-dot fa-xl" style={{ color: '#b80404' }}></i> </span>&nbsp;&nbsp;
                                <span>934 McCowan Road, Toronto M1P 3H6</span></p>
                            <p><i class="fa-solid fa-headset fa-xl" style={{ color: '#b80404' }}></i>&nbsp;&nbsp;+1 (647) 716-1330</p>

                            <p> <i class="fa-solid fa-envelope fa-xl" style={{ color: '#b80404' }}></i>&nbsp;&nbsp;info@rojancanada.com</p>

                        </div> */}
                    </div>
                </div>
            </div >
        </>
    );
}
